(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bw-hero-form"] && !Shopify.designMode) return;
  try {
    
  function initializeCbN8nForms(root) {
    root.querySelectorAll('[data-cb-n8n-form]').forEach((card) => {
      if (card.dataset.cbN8nReady === 'true') return;

      const form = card.querySelector('form.cb-wholesale__form');
      const submit = form?.querySelector('button[type="submit"]');
      const error = form?.querySelector('[data-cb-n8n-error]');
      const success = form?.querySelector('[data-cb-n8n-success]');

      if (!form || !submit || !error || !success) return;

      let endpoint;
      try {
        endpoint = new URL(card.dataset.cbN8nForm);
      } catch {
        return;
      }

      if (endpoint.protocol !== 'https:') return;
      card.dataset.cbN8nReady = 'true';

      const fieldValue = (name) => {
        const field = form.elements.namedItem(name);
        return typeof field?.value === 'string' ? field.value.trim() : '';
      };

      let sending = false;
      form.addEventListener('submit', () => {
        if (sending || !form.checkValidity()) return;
        sending = true;

        const ticketForm = card.dataset.cbFormType === 'fabtech_ticket';
        const payload = {
          Full_name: fieldValue('contact[name]'),
          Email: fieldValue('contact[email]'),
          Company_name: fieldValue('contact[Company]'),
          Phone: fieldValue('contact[phone]'),
          Shipping_State: ticketForm
            ? fieldValue('contact[City and state]')
            : fieldValue('contact[Shipping state]'),
          Estimated_Order_Size: ticketForm
            ? fieldValue('contact[Tickets requested]')
            : fieldValue('contact[Estimated order size (lbs)]'),
          Order_frequency: ticketForm
            ? fieldValue('contact[Customer status]')
            : fieldValue('contact[Order frequency]'),
          Product_interest: ticketForm
            ? fieldValue('contact[Job title]')
            : fieldValue('contact[Product interest]'),
          other_details: ticketForm
            ? fieldValue('contact[Ticket request acknowledgement]')
            : fieldValue('contact[Other product]'),
          Notes: fieldValue('contact[body]'),
          form_type: card.dataset.cbFormType || 'wholesale',
          enquiry_type: fieldValue('contact[Enquiry type]'),
          page_url: fieldValue('contact[Page]'),
          submitted_at: new Date().toISOString()
        };

        fetch(endpoint.toString(), {
            method: 'POST',
            body: new URLSearchParams(payload),
            mode: 'cors',
            credentials: 'omit',
            keepalive: true
          }).then((response) => {
            if (!response.ok) sending = false;
          }).catch(() => {
            sending = false;
          });
      }, { capture: true });
    });
  }

  initializeCbN8nForms(document);
  document.addEventListener('shopify:section:load', (event) => initializeCbN8nForms(event.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cb-fabtech-hero"] && !Shopify.designMode) return;
  try {
    
  function initializeFabtechBackgrounds() {
    document.querySelectorAll('[data-fabtech-background-video]').forEach((video) => {
      if (video.dataset.initialized) return;
      video.dataset.initialized = 'true';
      const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
      const button = video.closest('.cft-hero').querySelector('[data-fabtech-motion-toggle]');
      const syncButton = () => {
        button.hidden = false;
        button.textContent = video.paused ? button.dataset.playLabel : button.dataset.pauseLabel;
      };
      const play = () => {
        video.hidden = false;
        if (!video.src) video.src = video.dataset.fabtechBackgroundVideo;
        video.play().catch(syncButton);
      };
      const update = () => {
        if (reducedMotion.matches) { video.pause(); video.hidden = true; syncButton(); return; }
        play();
      };
      button.addEventListener('click', () => video.paused ? play() : video.pause());
      video.addEventListener('play', syncButton);
      video.addEventListener('pause', syncButton);
      reducedMotion.addEventListener('change', update);
      update();
    });
  }
  initializeFabtechBackgrounds();
  document.addEventListener('shopify:section:load', initializeFabtechBackgrounds);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      // Fonts, logo loading, resizing and sticky styles can change the height
      // after the initial measurement. Keep the contact bar's offset in sync.
      this.onHeaderResize = this.setHeaderHeight.bind(this);
      this.headerResizeObserver = new ResizeObserver(this.onHeaderResize);
      this.headerResizeObserver.observe(this.header);
      window.addEventListener('resize', this.onHeaderResize);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');
      this.languageMenus = this.querySelectorAll('.cb-header-language');
      this.onDocumentClick = this.handleDocumentClick.bind(this);
      this.onDocumentKeydown = this.handleDocumentKeydown.bind(this);

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);
      document.addEventListener('click', this.onDocumentClick);
      document.addEventListener('keydown', this.onDocumentKeydown);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.headerResizeObserver.disconnect();
      window.removeEventListener('resize', this.onHeaderResize);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
      document.removeEventListener('click', this.onDocumentClick);
      document.removeEventListener('keydown', this.onDocumentKeydown);
    }

    handleDocumentClick(event) {
      this.languageMenus.forEach((menu) => {
        if (menu.open && !menu.contains(event.target)) {
          menu.removeAttribute('open');
        }
      });
    }

    handleDocumentKeydown(event) {
      if (event.key !== 'Escape') return;

      this.languageMenus.forEach((menu) => {
        if (!menu.open) return;

        menu.removeAttribute('open');
        menu.querySelector('summary')?.focus();
      });
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
